<template>
  <div>
    <b-card
      :title="'Feature Flags'"
      title-tag="h5"
      class="rounded border mb-4"
    >
      <b-card-body>
        <div class="flag-columns header">
          <div>Name</div>
          <div>Description</div>
          <div style="margin: 0 auto;">
            Enabled
          </div>
        </div>
        <div
          v-for="(item, index) in featureFlags"
          :key="index"
          class="flag-item"
        >
          <div class="flag-columns">
            <div>{{ item.name }}</div>
            <div>{{ item.description }}</div>
            <div style="margin: 0 auto;">
              <b-form-checkbox
                v-model="item.enabled"
                switch
                @change="setFeatureFlag($event, item)"
              />{{  item.enabled }}
            </div>
          </div>
        </div>
        <no-content
          :show="featureFlags && !featureFlags.length"
          text="No Feature Flags Present"
        />
      </b-card-body>
    </b-card>
  </div>
</template>
  
<script>
  
import {createNamespacedHelpers} from 'vuex';
import NoContent from '@/core/components/NoContent.vue';
  
const {mapState, mapGetters, mapActions} = createNamespacedHelpers('systemInfo');
const {mapState: mapStateApp} = createNamespacedHelpers('app');
const {
  mapActions: mapActionsSidebar,
} = createNamespacedHelpers('sidebar');
  
export default {

  name: 'FeatureFlagsCard',

  components: {
    NoContent,
  },

  data() {
    return {
      /**
       * Feature Flags are copied locally from State so that the Enabled flag
       * can be set by the checkbox without directly interfering with State data.
       */
      featureFlags: [],
    };

  },

  computed: {
    ...mapState({
      featureFlagNames: state=> state.systemSettings.featureFlagNames,
    }),
    ...mapGetters({
      getFeatureFlags: 'getFeatureFlags',
    }),
    ...mapStateApp(['isFourthVersion']),
  },

  methods: {
    ...mapActions([
      'setFeatureFlagsData',
    ]),
    ...mapActionsSidebar(['getSidebarStructure']),

    /**
     * User has toggled the Feature Flag's Enabled state.
     * @param e Checkbox state (boolean).
     * @param item Feature flag definition.
     */
    async setFeatureFlag(e, item) {
      if (item.name === this.featureFlagNames.version4){
        /* Confirm Version change. */
        const confirm = await this.$confirm(
          'Application Version',
          'Do you want to change the UI version?',
        );
        if (!confirm) {
          item.enabled = !e;
          return;
        };
      }
      /* Update the Feature Flag to the BE and State. */
      const {success, body} = await this.setFeatureFlagsData(item);
      if(success){
        await this.getSidebarStructure();
      }
      this.$toasted[success ? 'success' : 'error'](
        success
          ? `The '${item.name}' flag was successfully updated.`
          : body.ErrorMessage,
        {duration: TOASTER_DURATION * (success ? 1 : 2 )},
      );
    },
  },

  /**
   * Called after the instance has finished processing all state-related options.
   */
  created() {
    /* Clone Feature Flags to local list. */
    this.getFeatureFlags.forEach(ff => this.featureFlags.push(JSON.parse(JSON.stringify(ff))));
  },

};
</script>
<style scoped lang="scss">
.flag-item {
  margin-bottom: 5px;
  padding: 10px;
  border-bottom: 1px solid #eeee;
}

.flag-columns {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.header{
  border-bottom: 1px solid black;
  font-weight: 600;
  padding: 10px;
}
</style>